import React from "react";
import { CustomLabel } from "../../Constant";
import { useIsMobile } from "../../Hooks/useIsMobile";
import { useSelector } from "react-redux";
import "./style.css";

const BannerWrapper = ({ children }) => {
  const isMobile = useIsMobile();
  const agentDataSelected = useSelector((state) => state.agData.agentData);
  const intersubcatSelected = useSelector((state) => state.agData.loginData);
  return (
    <>
      <div className="bg_blue mt-5">
        <div className="row mt-5">
          <div
            className={isMobile ? "col-md-12 p-0 text-center" : "col-md-12 p-0"}
          >
            <div
              class={isMobile ? "jumbotron" : "jumbotron pt-3 p-4 mt-5"}
              style={{ marginTop: `${isMobile ? "80px" : "0px"}` }}
            >
              <h3 class="text-white">
                Welcome{" "}
                {intersubcatSelected.intermedsubcatcd === "AGENT"
                  ? agentDataSelected && agentDataSelected.agentName
                  : agentDataSelected && agentDataSelected.agentName}
              </h3>
              <p className="text-white">
                DMS Code -{" "}
                {intersubcatSelected.intermedsubcatcd === "AGENT"
                  ? agentDataSelected && agentDataSelected.agentId
                  : agentDataSelected && agentDataSelected.agentId}
              </p>
              <CustomLabel
                font_size="28"
                color="white"
                font_weight="normal"
                margin_top={isMobile ? "0" : "10"}
              >
                Select your Product
              </CustomLabel>
            </div>
          </div>
        </div>
      </div>
      {children}
    </>
  );
};

export default BannerWrapper;
